export default "__VITE_ASSET__BWzhA8bA__"